/* rb-b-pills.js — collapse duplicate active-filter pills in the results bar.

   RUNS EVERYWHERE, DESKTOP AND MOBILE, since 10 Sep. It was briefly gated at
   981px under "mobile should be exactly as it is on the live site", on the
   reasoning that the merges it cleans up after could not happen on mobile
   anyway because rb-b-sizeclean.js and rb-b-shoes.js were gated too.

   Those two now run on mobile, so that reasoning has inverted: this file MUST
   run there as well, or a mobile shopper tapping the merged "9" chip gets a
   results bar reading "09  42" — several raw values where the chip said one.
   Gate and merge cleanup travel together; do not re-gate one without the
   other.

   Applying a merged size sends BOTH spellings (filter.v.option.size=S and
   =Small), because that is how the union is expressed to Shopify. The theme
   then renders one active pill per value, so the bar reads 'S  Small' — which
   exposes the trick and reads as a duplicate.

   THREE THINGS WENT WRONG HERE. All are worth knowing:

   1. The first version decided as it iterated — mark the first of a kind seen,
      hide the rest. With the bar re-rendering mid-pass, both pills ended up
      relabelled and neither hidden. It GROUPS FIRST now, which is
      deterministic however many times it runs.

   2. Running on a debounce was too slow. The bar is rendered a beat after the
      grid, so the duplicate was visible for a moment. The observer now calls
      run() SYNCHRONOUSLY as nodes are inserted; run() costs nothing when there
      are fewer than two pills, which is almost always.

   3. While the duplicate was still visible, clicking it removed only ITS value
      and left the other applied — the count went to 285 instead of clearing.
      A symptom of 2, not a separate bug.

   SHOE SIZES (added with rb-b-shoes.js): the same problem in a second shape.
   Picking the merged "12" chip sends 12, 12 (EU 45) and 12 (EU 46), and the
   bar showed all three side by side. norm() folds a trailing parenthetical off
   a numeric value so those share one key. Two details that matter:

     - the paren rule is deliberately narrow, matching only "<number> (...)".
       Stripping parentheses generally would merge unrelated values, and "9 mm"
       must stay distinct from "9" — it has no parens, so it does.
     - the SURVIVOR rule had to change. "Keep the fullest spelling" is right
       for Small over S, but wrong here: it would leave "12 (EU 46)" on screen
       under a chip labelled "12". Pills without parentheses now win first,
       and length only breaks ties among those.

   Removing the surviving pill clears EVERY value in its group. If the group's
   inputs cannot be found it does nothing and lets the theme's href behave
   normally. */

(function () {
  'use strict';

  /* GATE REMOVED 10 Sep — runs on mobile too. It HAS to: the merges that
     produce duplicate pills (rb-b-sizeclean, rb-b-shoes) now run on mobile,
     so without this the mobile bar would read "09  42" after a single tap. */

  /* EU-only shoe sizes now fold into the US chip (rb-b-shoes.js), so their
     pills have to fold with them — otherwise clicking "9" leaves the bar
     reading "09  42". Same map, same source: the store's own paired values.
     Safe as a bare-number rule because nothing else in the size axis carries
     42-45 any more — belts stop at 40, and the one shirt that used 42/44/46
     was re-sized to letters on 10 Sep. */
  var EU_TO_US = { '42': '9', '43': '10', '44': '11', '45': '12' };

  function norm(v) {
    var s = (v || '').trim().toLowerCase();

    /* "12 (eu 45)" -> "12", "9.5 (eu 42)" -> "9.5". Numbers only, and only a
       trailing parenthetical — see the note above. */
    var m = s.match(/^0*(\d+(?:\.\d+)?)\s*\(.*\)$/);
    if (m) return String(parseFloat(m[1]));

    if (EU_TO_US[s]) return EU_TO_US[s];

    s = s.replace(/[\s\-_]+/g, '');
    s = s.replace(/extra/g, 'x');
    if (/^0\d+$/.test(s)) s = s.replace(/^0+/, '') || '0';
    var canon = {
      small: 's', medium: 'm', large: 'l',
      xsmall: 'xs', xlarge: 'xl', xxlarge: 'xxl', xxxlarge: 'xxxl',
      onesizefitsmost: 'onesize', osfm: 'onesize', os: 'onesize', onesize: 'onesize'
    };
    return canon[s] || s;
  }

  function pillText(a) {
    return (a.textContent || '').trim().replace(/\s+/g, ' ');
  }

  function inputsFor(key) {
    var out = [];
    document.querySelectorAll('.collection-sidebar__filter-group--size input').forEach(function (i) {
      if (norm(i.value) === key) out.push(i);
    });
    return out;
  }

  function run() {
    var pills = Array.prototype.slice.call(document.querySelectorAll(
      '.collection__filters-active__filter:not(.collection__filters-active__filter--clear)'));
    /* Was "< 2" — a single pill could never be a duplicate. It can still be
       MISLABELLED though: an EU-only value is the lone pill behind a merged
       chip on /collections/the-weekender, and the early return meant it kept
       reading "42" under a chip reading "9". */
    if (!pills.length) return;

    // GROUP FIRST — never decide while iterating.
    var byKey = {};
    pills.forEach(function (p) {
      var k = norm(pillText(p));
      (byKey[k] = byKey[k] || []).push(p);
    });

    Object.keys(byKey).forEach(function (k) {
      var set = byKey[k];

      /* A group of one still needs relabelling when its single value is an
         EU-only size: on /collections/the-weekender the merged chip reads
         "9" but the only value behind it is 42, so nothing collapses and the
         bar would say "42" under a chip that said "9". Text only — the
         pill's own href still removes exactly the value it always did. */
      if (set.length === 1) {
        var only = set[0];
        var t = pillText(only);
        if (EU_TO_US[t.toLowerCase()] && only.dataset.rbbRelabel !== '1') {
          only.dataset.rbbRelabel = '1';
          var done = false;
          Array.prototype.forEach.call(only.childNodes, function (n) {
            if (n.nodeType === 3 && n.textContent.trim()) {
              n.textContent = done ? '' : EU_TO_US[t.toLowerCase()];
              done = true;
            }
          });
          if (!done) only.textContent = EU_TO_US[t.toLowerCase()];
        }
        return;
      }

      /* Survivor rule, in order: for a NUMERIC group, a pill that already
         reads exactly like the key wins outright — that is what keeps "9" on
         screen instead of "09" or "42" once the EU sizes fold in. Then plain
         beats parenthesised ("12" over "12 (EU 45)"). Then the fullest
         spelling wins ("Small" over "S").

         THE EXACT-MATCH TEST IS NUMERIC-ONLY, and that restriction is the
         whole point. Without it the rule fires on the letter groups too: the
         key for Small/S is the canonical "s", the pill "S" matches it
         exactly, and so "S" beat "Small" — which is precisely what shipped
         this morning and turned up on /collections/accessories, where
         tapping the chip labelled "Small" left a bar reading "S". A canonical
         key is not a label; only for numbers are the two the same string. */
      var numericKey = /^\d/.test(k);
      set.sort(function (a, b) {
        var at = pillText(a), bt = pillText(b);
        var ae = (numericKey && at.toLowerCase() === k) ? 0 : 1;
        var be = (numericKey && bt.toLowerCase() === k) ? 0 : 1;
        var ap = /\(/.test(at) ? 1 : 0;
        var bp = /\(/.test(bt) ? 1 : 0;
        return ae - be || ap - bp || bt.length - at.length;
      });
      var keep = set[0];

      set.slice(1).forEach(function (p) { p.style.setProperty('display', 'none', 'important'); });
      keep.style.removeProperty('display');

      if (keep.dataset.rbbPill === '1') return;
      keep.dataset.rbbPill = '1';
      keep.addEventListener('click', function (ev) {
        var inputs = inputsFor(k);
        if (inputs.length < 2) return;     // nothing merged to clear; use the href
        ev.preventDefault();
        inputs.forEach(function (i) { i.checked = false; });
        inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* The tail out to 6s is not padding. Measured on /collections/footwear:
     clicking the merged "9" chip sends five values, and reading the bar at
     4.5s still showed "09" and "42" while 5.0s showed the single "9" — so
     the theme can finish rendering pills after the old 2s tail had run out,
     leaving a duplicate on screen until the next mutation. run() costs
     nothing below two pills, which is the overwhelmingly common case. */
  function sweep() {
    [0, 100, 250, 600, 1200, 2000, 3500, 6000].forEach(function (ms) {
      setTimeout(run, ms);
    });
  }

  function boot() {
    sweep();
    if (!window.MutationObserver) return;
    var section = document.querySelector('.js-section__collection') || document.body;

    /* Synchronous on insertion: the duplicate must never be painted. run() is
       a no-op with fewer than two pills, so this is cheap despite firing on
       every mutation in the section. */
    new MutationObserver(function () {
      run();
      sweep();
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
